import axios from 'axios'
import i18n from '@/plugins/i18n/i18n'
import { randomBaseUrl } from '@/js/utils/randomBaseUrl'

export const signUpMe = (uri, params) => new Promise((resolve, reject) => {
  const currentLanguage = (i18n.locale == 'en-EN') || (i18n.locale == 'en') ? 'en' :
  (i18n.locale == 'fr-FR') || (i18n.locale == 'fr') ? 'fr' :
  (i18n.locale == 'nl-NL') || (i18n.locale == 'nl') ? 'nl' : 'fr'

  let alert = false
  let alertType = 'error'
  let alertMessage = i18n.messages[currentLanguage]['basic-message']['error-message']

  axios.get(randomBaseUrl(0, 3) + process.env.VUE_APP_CREATE_LOGIN_ENDPOINT + uri)
    .then(response => {
      const status = response.data.status
      const subject = response.data.message
      // check the response status
      if (status === 'error') {
        switch (subject) {
          case 'Login exists':
            alertType = 'error'
            alertMessage = i18n.messages[currentLanguage]['signup-screen']['alertMsg']['login-exists']
            break

          case 'Login too short':
            alertType = 'error'
            alertMessage = params.username.length > 0 ? i18n.messages[currentLanguage]['signup-screen']['alertMsg']['login-shoort']['msg-1'] : i18n.messages[currentLanguage]['signup-screen']['alertMsg']['login-shoort']['msg-2']
            break

          case 'No email provided':
            alertType = 'error'
            alertMessage = i18n.messages[currentLanguage]['signup-screen']['alertMsg']['no-email']
            break

          case 'Cannot send email, please try again later':
            alertType = 'error'
            alertMessage = i18n.messages[currentLanguage]['signup-screen']['alertMsg']['cannot-send']
            break

          case 'Password should contain lowercase letters':
            alertType = 'error'
            alertMessage = i18n.messages[currentLanguage]['signup-screen']['alertMsg']['pswrd-lower']
            break

          case 'Password should contain uppercase letters':
            alertType = 'error'
            alertMessage = i18n.messages[currentLanguage]['signup-screen']['alertMsg']['pswrd-upper']
            break

          case 'Password should contain numbers':
            alertType = 'error'
            alertMessage = i18n.messages[currentLanguage]['signup-screen']['alertMsg']['pswrd-number']
            break

          case 'Password should contain non alphanumeric characters':
            alertType = 'error'
            alertMessage = i18n.messages[currentLanguage]['signup-screen']['alertMsg']['pswrd-digit']
            break

          case 'Password too short':
            alertType = 'error'
            alertMessage = params.password.length > 0 ? i18n.messages[currentLanguage]['signup-screen']['alertMsg']['pswrd-shoort']['msg-1'] : i18n.messages[currentLanguage]['signup-screen']['alertMsg']['pswrd-shoort']['msg-2']
            break

          default:
            alertType = 'error'
            alertMessage = i18n.messages[currentLanguage]['basic-message']['error-message']
            break
        }
        alert = true // show alert box
      } else if (status === 'ok') {
        alert = false // remove a potential alert box
        // normally not showing info but we change it just in case
        alertType = 'success'
        alertMessage = i18n.messages[currentLanguage]['signup-screen']['alertMsg']['success']
      } else { // normaly impossible case with no error but no correct response
        alertType = 'error'
        alertMessage = i18n.messages[currentLanguage]['basic-message']['error-message']
        alert = true // show alert box
      }
      resolve({
        status: status,
        alert: alert,
        alertType: alertType,
        alertMessage: alertMessage
      })
    })
    .catch(() => {
      // error
      alertType = 'error'
      alertMessage = i18n.messages[currentLanguage]['basic-message']['error-message']
      alert = true // show alert box

      reject({
        alert: alert,
        alertType: alertType,
        alertMessage: alertMessage
      })
    })
})
